import { Injectable, OnDestroy } from '@angular/core';
import { interval, Subscription, Subject, fromEvent } from 'rxjs';
import { filter, throttleTime } from 'rxjs/operators';
import { SettingsService } from '@stockcare-services/settings-service/settings.service';
import { Settings } from '@stockcare-helpers/settings';

@Injectable({
  providedIn: 'root',
})
export class ActivityService implements OnDestroy {
  subscriptions = new Subscription();
  lastInteraction: Date;
  intervalDelay = 1000;
  maximumInactivityInterval: number;
  isRunning = false;
  userIsInactive = new Subject();

  constructor(private settingsService: SettingsService) {
    this.GetSettings();

    this.subscribeToSettingsChanged();

    this.subscribeToMouseMove();

    this.subscribeMouseClick();
  }

  private subscribeToSettingsChanged() {
    this.subscriptions.add(
      this.settingsService.settingsUpdated
        .pipe(
          filter((settings) =>
            this.settingsService.hasSettingBeenUpdated(
              Settings.INACTIVITY_TIMEOUT,
              settings
            )
          )
        )
        .subscribe(() => {
          this.GetSettings();
        })
    );
  }

  interact() {
    if (this.isRunning) {
      this.lastInteraction = new Date();
    }
  }

  initialize() {
    console.log('Starting activity service');
    this.checkInteraction();
  }

  start() {
    this.lastInteraction = new Date();
    this.isRunning = true;
  }

  stop() {
    this.isRunning = false;
  }

  checkInteraction() {
    this.subscriptions.add(
      interval(this.intervalDelay)
        .pipe(filter(() => this.isRunning))
        .subscribe(() => {
          if (
            new Date().getTime() - this.lastInteraction.getTime() >
            this.maximumInactivityInterval
          ) {
            this.userIsInactive.next(true);
          }
        })
    );
  }

  private subscribeMouseClick() {
    this.subscriptions.add(
      fromEvent(document, 'mousemove')
        .pipe(throttleTime(200))
        .subscribe(() => {
          this.interact();
        })
    );
  }

  // tslint:disable-next-line: no-identical-functions
  private subscribeToMouseMove() {
    this.subscriptions.add(
      fromEvent(document, 'click')
        .pipe(throttleTime(200))
        .subscribe(() => {
          this.interact();
        })
    );
  }

  private GetSettings() {
    this.maximumInactivityInterval =
      this.settingsService.getSettingValue(Settings.INACTIVITY_TIMEOUT) * 1000;
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
}
